import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonChip, IonItem, IonLabel } from '@ionic/vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Round',
  props: {
    value: {},
    color: {},
    title: {},
    highlight: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonItem), {
    disabled: !_ctx.value,
    color: _ctx.value ? _ctx.color : 'light'
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonLabel), null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.title), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(IonChip), {
        slot: "end",
        outline: "true",
        color: _ctx.highlight || !_ctx.value ? 'light' : 'dark'
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.value), 1)
        ]),
        _: 1
      }, 8, ["color"])
    ]),
    _: 1
  }, 8, ["disabled", "color"]))
}
}

})